import { type CarType, SteeringPosition } from "../../../../shared-logic/types/CarType";
import { initialExtraBase } from "../../../../shared-logic/types/CarType";
import type { CarActionsType } from "../actions/CarActions";
import { INIT_CAR } from "../actions/CarActions";
import { CERTIFICATION_NONE, getDefaultPriceObject } from "../../../../../common-deprecated/constants";

export const initialState: CarType = {
    id: "",
    shortId: 0,
    name: "",
    certification: CERTIFICATION_NONE,
    price: { ...getDefaultPriceObject() },
    efficiencyClass: "",
    availableForOnlineSales: false,
    availableForOnlineReservation: false,
    availableForOnlineLeasing: false,
    availability: {
        showAccessoriesRateCarConfig: false,
        showAnnualInterestRate: false,
        showEffectiveInterestRate: false,
        showFinanceButton: false,
        showInsuranceButton: false,
        showMonthlyRate: false,
        showProductName: false,
        showTerm: false,
        showInsurancePremiumCarConfig: false,
    },
    model: {
        id: "",
        name: "",
        webtitleSectionName: "",
        configVersion: "",
        internalCode: "",
        defaultCCISBackground: "",
        labels: [],
        defaultCar: "",
        steering: SteeringPosition.Left,
    },
    submodel: null,
    grade: {
        id: "",
        name: "",
        webtitleSectionName: "",
    },
    body: {
        id: "",
        name: "",
        webtitleSectionName: "",
    },
    motorization: {
        engine: {
            id: "",
            name: "",
            hybrid: false,
            electric: false,
            fuelCell: false,
            plugin: false,
            internalCode: "",
            type: "",
            typeCode: "",
        },
        transmission: {
            id: "",
            internalCode: "",
            name: "",
        },
        wheeldrive: {
            id: "",
            internalCode: "",
            name: "",
            description: "",
        },
    },
    colour: {
        id: "",
        shortId: "",
        code: "",
        internalCode: "",
        name: "",
        type: "",
        price: { ...getDefaultPriceObject() },
        rgb: "",
        standard: false,
        image: "",
        upholsteries: [],
        upholsteriesCarConfigurator: [],
        upholsteryOnlineAvailability: [],
        description: null,
    },
    upholstery: {
        id: "",
        objectType: "upholstery",
        shortId: "",
        internalCode: "",
        name: "",
        price: { ...getDefaultPriceObject() },
        default: false,
        standard: false,
        image: "",
        description: null,
        index: 0,
        sortIndex: 0,
        availableForColours: [],
    },
    wheel: {
        ...initialExtraBase,
        objectType: "wheel",
        isWheel: true,
        setItems: [],
    },
    packs: [],
    financePacks: [],
    extras: [],
    eco: [],
    serviceProducts: [],
    winterWheel: null,
    manualPromotions: [],
    visibleInTopSpin: false,
    soldOut: false,
    availableForBusinessLeasing: false,
};

// TODO Fix the default initial state, logged in OR-6661
const carReducer = (state: CarType = initialState, action: CarActionsType): CarType => {
    switch (action.type) {
        case INIT_CAR:
            return action.car;

        default:
            return state;
    }
};

export default carReducer;
